// extracted by mini-css-extract-plugin
export default {"pageContainer":"PDFReader_pageContainer__NJlKX","actions":"PDFReader_actions__bk-uY"};